import axios from '@fs/zion-axios'

const BASE_FAMILY_CARDS_PATH = '/service/dmc/family-cards'

export async function createCards(createCardsRequest, excludeContactInfo, locale) {
  const response = await axios.post(
    `${BASE_FAMILY_CARDS_PATH}?excludeContactInfo=${excludeContactInfo}&locale=${locale}`,
    createCardsRequest
  )
  return response
}

export async function getCards(id) {
  const response = await axios.get(`${BASE_FAMILY_CARDS_PATH}/${id}`, {
    responseType: 'arraybuffer',
  })
  return response
}

export async function getCardsLanguages() {
  const response = await axios.get(`${BASE_FAMILY_CARDS_PATH}/languages`)
  return response
}
